'use client';

import React from 'react';
import { CheckCircle } from 'lucide-react';

const TrustSection = () => {
  return (
    <section className="py-12 px-4 md:px-8 bg-primary-600 text-foreground">
      <div className="max-w-xl md:max-w-4xl mx-auto text-center">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
          <TrustItem
            title="Esperienza decennale"
            description="Creato dallo stesso team che ha digitalizzato il lavoro di migliaia di professionisti italiani."
          />
          <TrustItem
            title="Precisione assoluta"
            description="Basato unicamente su fonti ufficiali, continuamente aggiornate e verificabili."
          />
          <TrustItem
            title="Efficienza e sicurezza"
            description="Progettato per farti risparmiare tempo prezioso e minimizzare il rischio di errori."
          />
        </div>
      </div>
    </section>
  );
};

interface TrustItemProps {
  title: string;
  description: string;
}

const TrustItem: React.FC<TrustItemProps> = ({ title, description }) => {
  return (
    <div className="flex flex-col">
      <div className="text-lg font-semibold text-white mb-2">
        <CheckCircle className="inline w-5 h-5 -mt-1 mr-1 text-accent" /> {title}
      </div>
      <div className="text-base text-white/80">{description}</div>
    </div>
  );
};

export default TrustSection;
